import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  CircularProgress,
  Divider,
  TextField,
} from "@material-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Container from "@material-ui/core/Container";
import clsx from "clsx";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  deleteUser,
  getUsers,
  searchUsers,
  bulkUpdateUserGroup,
} from "../../../service/endpoint-manager";
import IconButton from "@material-ui/core/IconButton";
import Loading from "../Shared/Loading";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { useSnackbar } from "notistack";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Skeleton from "@mui/material/Skeleton";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import SelectTable from "./SelectTable";
import { useNavigate } from "react-router-dom";
import { USERS_PER_PAGE } from "../../../types/micellinous-constants";
import { returnUserGroupName } from "@thequantumhub/iam-package";

var userGroupOptions = [];

const BulkUpdate = ({
  setBulkUpdatedSelected,
  AssociatedUsersForBulkUpdate,
  userGroupId,
  setUserGroupId,
  userGroups,
}) => {
  const useStyles = makeStyles((theme) => ({
    containerStyles: {
      "&.MuiContainer-root": {
        [theme.breakpoints.down("md")]: {
          paddingLeft: "5px",
          paddingRight: "5px",
          // border: '1px solid red',
        },
      },
    },
    userAccessStyles: {
      fontFamily: "poppins, sans-serif",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },

    componentHeadingStyles: {},

    search: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      },
    },

    searchField: {
      marginLeft: "2vh",
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        marginBottom: "0.5rem",
      },
    },
    selectUserGroup: {
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        marginBottom: "0.5rem",
      },
    },
    label: { display: "flex", alignItems: "center", marginRight: "4vh" },
    dropdown: {
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",

      marginRight: "5%",
      backgroundColor: "#f7f7f7",
      height: "2.5rem",
      width: "15rem",
      lineHeight: "2rem",
    },
    menuItems: { display: "block" },

    SelectUserTitleLeft: {
      marginTop: "1vh",
      marginBottom: "1vh",
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        justifyContent: "space-between",
        marginTop: "0.5rem",
      },
    },
    SaveButtonRight: {
      display: "flex",
      justifyContent: "flex-end",

      [theme.breakpoints.down("md")]: {
        width: "100%",
        justifyContent: "space-between",
        marginTop: "0.5rem",
      },
    },

    searchBoxStyles: {
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
      paddingTop: "0.6rem",
      paddingBottom: "0.6rem",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },

    btnStyles: {
      background: "#1B2132",
      color: "#fff",
      fontSize: ".8rem",
    },

    tableBtn: {
      background: "#1b2132",
    },

    searchBtnStyles: {
      fontSize: ".8rem",
    },

    tableContainer: {
      margin: "1rem 0",
    },

    tableHeaderStyles: {
      fontWeight: "bold",
    },
    tableCellStyles: {
      width: "24vh",
    },
    tableCellStylesSrNum: {
      width: "5vh",
      alignItems: "center",
    },
    cta: {
      display: "flex",
      justifyContent: "flex-end",
    },

    saveBtnStyles: {
      width: "10rem",
    },

    userGroups: {
      cursor: "pointer",
      minWidth: "24vh",
      "&:hover": {
        textDecoration: "underline",
      },
    },

    deleteIconStyles: {
      "&:hover": {
        color: "red",
      },
    },

    dialogCancelBtn: {
      background: "#8a8a8a",
    },

    dialogStyles: {
      "& .MuiPaper-root": {
        width: "100%",
        maxWidth: "400px",
        borderRadius: "20px",
        paddingBottom: "1.25rem",
      },
    },

    dialogActionStyles: {
      display: "flex",
      justifyContent: "space-between",
      margin: "auto 1rem",
    },

    dialogDeleteBtnStyles: {
      "&:hover": {
        background: "#ff0000",
      },
    },

    accordionSection: {
      margin: "2rem 0",
    },

    mobileHeading: {
      display: "flex",
      alignItems: "center",
      paddingLeft: "1rem",
    },

    accordionDetails: {
      display: "flex",
      alignItems: "center",
      "& > section": {
        flex: "2 1 33%",
        textAlign: "center",
      },
    },
    paginatorUl: {
      justifyContent: "center",
      padding: "10px",
    },
    paginationIcon: {
      color: "white",
      marginRight: 20,
      marginLeft: 20,
      cursor: "pointer",
      backgroundColor: "#1B2132",
      "&:hover": {},
    },
    disabledPaginationIcon: {
      color: "white",
      marginRight: 20,
      marginLeft: 20,

      backgroundColor: "grey",
      "&:hover": {},
    },
  }));

  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [lastEvaluatedUserId, setLastEvaluatedUserId] = useState(null);

  const [openBulkUpdateConfirmDialog, setOpenBulkUpdateConfirmDialog] =
    React.useState(false);
  const [openDeleteUserDialog, setOpenDeleteUserDialog] = React.useState(false);

  const [users, setUsers] = useState(null);
  const usersPerPage = USERS_PER_PAGE;
  const [finalPageCount, setFinalPageCount] = useState(1);
  const [userPage, setUserPage] = React.useState(1);

  const [searchQuery, setSearchQuery] = useState(null);
  const [searchedUsers, setSearchedUsers] = useState(null);
  const [userToDelete, setUserToDelete] = useState(null);

  // store the number of rows that are selected at any given time in the bulkUpdate table
  const [numSelectedRows, setNumSelectedRows] = useState(0);

  // indicate whether or not the selectAll checkbox has been clicked
  const [selectAllClicked, setSelectAllClicked] = useState(false);

  // this state variable will store a list of IDs of selected users
  const [selectedUsers, setSelectedUsers] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (AssociatedUsersForBulkUpdate?.length > 0) {
      setSelectedUsers([...selectedUsers, ...AssociatedUsersForBulkUpdate]);
    }
  }, []);

  // this useEffect gets users when component initially renders
  useEffect(() => {
    if ((searchQuery === null || searchQuery === "") && !searchedUsers) {
      const getUsersFunction = async () => {
        setLoading(true);

        const result = await getUsers(usersPerPage, lastEvaluatedUserId);
        if (result?.status === 200) {
          setUsers(result?.data?.body?.Items);

          if (result?.data?.body?.LastEvaluatedKey) {
            setLastEvaluatedUserId(
              result?.data?.body?.LastEvaluatedKey?.user_id
            );
            setFinalPageCount(finalPageCount + 1);
          } else {
            setLastEvaluatedUserId(null);
            setFinalPageCount(userPage);
          }
        }
        setLoading(false);
      };
      getUsersFunction();
    } else if (searchedUsers && (searchQuery === null || searchQuery === "")) {
      setSearchedUsers(null);
      setUserPage(1);
      setFinalPageCount(0);
    }
  }, [searchQuery]);

  const handlePageBack = () => {
    if (userPage != 1) {
      setUserPage(userPage - 1);
    }
  };

  const returnUserGroupName = (id) => {
    const name = userGroups?.find((userGroup) => {
      if (userGroup.ID === id) {
        return userGroup.name;
      }
    });

    return name;
  };

  const handlePageForward = () => {
    // TODO it fails for one case ->
    // TODO 1st go to last page
    // TODO Make a search and then remove search
    // TODO It will allow you to go to next last page
    const currentPage = userPage;

    if (userPage !== finalPageCount || finalPageCount === null) {
      setUserPage(currentPage + 1);

      if (lastEvaluatedUserId) {
        const getUsersFunction = async () => {
          setLoadingUsers(true);
          const result = await getUsers(usersPerPage, lastEvaluatedUserId);
          if (result?.status === 200) {
            setUsers([...users, ...result?.data?.body?.Items]);
            if (result?.data?.body?.LastEvaluatedKey) {
              setLastEvaluatedUserId(
                result?.data?.body?.LastEvaluatedKey?.user_id
              );
              setFinalPageCount(currentPage + 1 + 1);
            } else {
              setLastEvaluatedUserId(null);
              setFinalPageCount(currentPage + 1);
            }
          }
          setLoadingUsers(false);
        };
        getUsersFunction();
      }
    }
  };

  const handlePageBackSearch = () => {
    if (userPage != 1) {
      setUserPage(userPage - 1);
    }
  };

  const handlePageForwardSearch = () => {
    if (userPage * usersPerPage < searchedUsers.length) {
      setUserPage(userPage + 1);
    }
  };

  const handleUserClick = (id) => {};

  // method to handle opening BulkUpdateConfirm dialog
  const handleOpenBulkUpdateConfirmDialog = () => {
    setOpenBulkUpdateConfirmDialog(true);
  };

  // method to handle closing BulkUpdateConfirm dialog
  const handleCloseBulkUpdateConfirmDialog = () => {
    setOpenBulkUpdateConfirmDialog(false);
  };

  // method to handle opening deleteUserGroup dialog
  const handleOpenDeleteUserDialog = (user_id) => {
    setUserToDelete(user_id);
    setOpenDeleteUserDialog(true);
  };

  // method to handle closing addUserGroup dialog
  const handleCloseDeleteUserDialog = () => {
    setUserToDelete(null);
    setOpenDeleteUserDialog(false);
  };

  // method to handle closing addUserGroup dialog
  const handleDeleteUserDialog = () => {
    const deleteUserFunction = async () => {
      setLoadingUsers(true);
      const response = await deleteUser(userToDelete);

      if (response?.status === 200) {
        const newUsers = users.filter((user) => user.user_id !== userToDelete);
        if (newUsers.length < usersPerPage) {
          const getUsersFunction = async () => {
            setLoadingUsers(true);
            const result = await getUsers(usersPerPage, null);
            if (result?.status === 200) {
              setUsers(result?.data?.body?.Items);
              if (result?.data?.body?.LastEvaluatedKey) {
                setLastEvaluatedUserId(
                  result?.data?.body?.LastEvaluatedKey?.user_id
                );
                setFinalPageCount(finalPageCount + 1);
              } else {
                setLastEvaluatedUserId(null);
                setFinalPageCount(userPage);
              }
            }
            setLoadingUsers(false);
          };
          getUsersFunction();
        } else {
          setUsers(newUsers);
        }
        enqueueSnackbar("User Deleted", {
          variant: "success",
        });
      } else if (response.code === "ERR_BAD_REQUEST") {
        enqueueSnackbar(response.response.data.message, {
          variant: "error",
        });
      } else if (response.code === "ERR_NETWORK") {
        enqueueSnackbar("Network error.", {
          variant: "error",
        });
      }
      setLoadingUsers(false);
    };
    deleteUserFunction();
    setUserToDelete(null);
    setOpenDeleteUserDialog(false);
  };

  // method to handle Bulk update of userGroup when Save button is clicked
  const handleUserGroupBulkUpdate = async () => {
    if (selectedUsers.length > 0) {
      const result = await bulkUpdateUserGroup(userGroupId, selectedUsers);
      if (result?.status === 200) {
        enqueueSnackbar(`${result?.data?.message}`, { variant: "success" });
        resetBulkUpdate();
        setSelectedUsers([]);
        window.location.reload(false);
      } else {
        enqueueSnackbar(`${result?.response?.data?.message}`, {
          variant: "error",
        });
      }
    }

    setOpenBulkUpdateConfirmDialog(false);
  };

  const handleSearchSubmit = async (event) => {
    event.preventDefault();

    setSearchLoading(true);

    const result = await searchUsers(searchQuery);
    if (result?.status === 200) {
      setSearchedUsers(result?.data?.body?.Items);
      setUserPage(1);
    }

    setSearchLoading(false);
  };

  // This handler updates the user group id after user chooses from dropdown
  const handleUserGroupSelection = (e) => {
    setUserGroupId(e.target.value);
  };

  // this useEffects populate userGroupOptions to be used in our Select component to choose user groups
  useEffect(() => {
    userGroups?.map((userGroup) => {
      if (userGroup.template != true) {
        userGroupOptions.push({
          id: userGroup.ID,
          value: userGroup.name,
          label: userGroup.name,
        });
      }
    });
  }, [userGroups]);

  const handleSelectAllUsers = (e) => {
    if (e.target.checked) {
      setSelectAllClicked(true);

      // reset the list of currently selected users
      setSelectedUsers([]);

      // add the IDs of all users to the list

      const allUsers = [];
      users.map((user) => {
        allUsers.push(user.user_id);
      });
      setSelectedUsers([...allUsers]);
    } else {
      setSelectAllClicked(false);
      setSelectedUsers([]);
    }
  };

  const handleRowSelectionChanged = (e, userid) => {
    if (e.target.checked) {
      // increment the number of selected rows
      setNumSelectedRows((numSelectedRows) => {
        return numSelectedRows + 1;
      });

      // add userId of selected user to list
      setSelectedUsers([...selectedUsers, userid]);
    } else {
      setNumSelectedRows((numSelectedRows) => {
        return numSelectedRows - 1;
      });

      setSelectedUsers(
        selectedUsers.filter((selectedUserID) => selectedUserID !== userid)
      );

      if (selectAllClicked) {
        setSelectAllClicked(false);
      }
    }
  };

  // if selectAll is clicked and new users are fetched, add those to the list of selected users
  useEffect(() => {
    if (selectAllClicked) {
      const allUsers = [
        ...users.map((user) => {
          return user.user_id;
        }),
      ];

      setSelectedUsers(allUsers);
    }
  }, [users]);

  useEffect(() => {
    setNumSelectedRows(selectedUsers.length);
  }, [selectedUsers]);

  const loadingUserLoader = () => {
    var tableCell = [];
    for (let i = 0; i < usersPerPage; i++) {
      tableCell.push(
        <TableRow key={i}>
          <TableCell className={classes.tableHeaderStyles}>
            <Skeleton animation="wave" />
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            className={classes.tableCellStyles}
          >
            <Skeleton animation="wave" />
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            className={classes.tableCellStyles}
          >
            <Skeleton animation="wave" />
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            className={classes.tableCellStyles}
          >
            <Skeleton animation="wave" />
          </TableCell>

          <TableCell
            component="th"
            scope="row"
            className={classes.tableCellStyles}
          >
            <IconButton aria-label="delete">
              <DeleteForeverIcon className={classes.deleteIconStyles} />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    }
    return tableCell;
  };

  const resetBulkUpdate = () => {
    setUserGroupId(null);
    userGroupOptions = [];

    setBulkUpdatedSelected(false);
    setSelectedUsers([]);
  };
  if (loading) {
    return <Loading />;
  }
  return (
    <Container width="sm" className={classes.containerStyles}>
      <section className={classes.userAccessStyles}>
        <h1 className={classes.componentHeadingStyles}>
          <IconButton
            onClick={() => {
              resetBulkUpdate();
              navigate("/users");
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          {!searchedUsers
            ? "Bulk Update"
            : `${searchedUsers.length} Search Results`}
        </h1>

        <div className={classes.SelectUserTitleLeft}>
          <Typography className={classes.SelectUserTitleLeft}>
            Select a User Group
          </Typography>
          <span className={classes.SaveButtonRight}>
            <Button
              variant="contained"
              className={classes.btnStyles}
              disabled={selectedUsers.length === 0}
              onClick={() => {
                // open Bulk update confirmation dialog
                setOpenBulkUpdateConfirmDialog(true);
              }}
            >
              Save
            </Button>
          </span>
        </div>
        <Divider />
        <Typography className={classes.SelectUserTitleLeft}>
          Select a User Group to attach to your users
        </Typography>
        <section className={classes.search}>
          {userGroupOptions && userGroupId && userGroups ? (
            <label className={classes.label}>
              <p style={{ marginRight: "2vh" }}>UserGroup</p>
              <FormControl style={{ marginLeft: "2vh" }} fullWidth>
                <Select
                  option={userGroups}
                  defaultValue={userGroupId}
                  onChange={(e) => {
                    handleUserGroupSelection(e);
                  }}
                  className={classes.dropdown}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                >
                  {userGroups?.map((userGroup, index) =>
                    userGroup?.template == false ? (
                      <MenuItem
                        key={userGroup?.ID}
                        value={userGroup?.ID}
                        className={classes.menuItems}
                      >
                        {userGroup?.name}
                      </MenuItem>
                    ) : (
                      <MenuItem></MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
            </label>
          ) : (
            <></>
          )}
        </section>
        {
          <>
            {" "}
            <div className={classes.SelectUserTitleLeft}>
              <Typography className={classes.SelectUserTitleLeft}>
                Select Users
              </Typography>
            </div>
            <Divider />
            <Typography className={classes.SelectUserTitleLeft}>
              Select Users to update, you may also search via username
            </Typography>
            <section className={classes.search}>
              <label className={classes.label}>
                <p style={{ marginRight: "2vh" }}>Username</p>
                <form
                  onSubmit={(e) => handleSearchSubmit(e)}
                  style={{ alignItems: "center", display: "flex" }}
                >
                  <div className={classes.searchField}>
                    <TextField
                      variant="outlined"
                      size="small"
                      placeholder="Search User"
                      className={classes.searchBoxStyles}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      value={searchQuery ? searchQuery : ""}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <Button
                      variant="contained"
                      type="submit"
                      className={clsx(
                        classes.btnStyles,
                        classes.searchBtnStyles
                      )}
                    >
                      Search
                    </Button>
                    {searchLoading ? (
                      <CircularProgress
                        size="1.5rem"
                        style={{ marginLeft: 10 }}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </form>
              </label>
            </section>
            {/* table  -renders on large screens and up*/}
            {!searchedUsers ? (
              <SelectTable
                returnUserGroupName={returnUserGroupName}
                numSelectedRows={numSelectedRows}
                users={users}
                selectAllClicked={selectAllClicked}
                handleSelectAllUsers={handleSelectAllUsers}
                userPage={userPage}
                usersPerPage={usersPerPage}
                handleRowSelectionChanged={handleRowSelectionChanged}
                selectedUsers={selectedUsers}
                handleOpenDeleteUserDialog={handleOpenDeleteUserDialog}
                finalPageCount={finalPageCount}
                handleUserClick={handleUserClick}
                loading={loading}
                loadingUsers={loadingUsers}
                handlePageBack={handlePageBack}
                handlePageForward={handlePageForward}
              />
            ) : (
              <SelectTable
                returnUserGroupName={returnUserGroupName}
                numSelectedRows={numSelectedRows}
                users={searchedUsers}
                selectAllClicked={selectAllClicked}
                handleSelectAllUsers={handleSelectAllUsers}
                userPage={userPage}
                usersPerPage={usersPerPage}
                handleRowSelectionChanged={handleRowSelectionChanged}
                selectedUsers={selectedUsers}
                handleOpenDeleteUserDialog={handleOpenDeleteUserDialog}
                finalPageCount={finalPageCount}
                handleUserClick={handleUserClick}
                loading={loading}
                loadingUsers={loadingUsers}
                handlePageBack={handlePageBackSearch}
                handlePageForward={handlePageForwardSearch}
                search={true}
              />
            )}
            <section className={classes.cta}></section>
            {/* Add User Group Dialog - opens when 'Add User Group' button is clicked */}
            <Dialog
              open={openBulkUpdateConfirmDialog}
              onClose={handleCloseBulkUpdateConfirmDialog}
              maxWidth="lg"
              className={classes.dialogStyles}
            >
              <DialogTitle id="add-userGroup-dialog">Bulk Update</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to save userGroup changes for all
                  selected users?
                </DialogContentText>
              </DialogContent>
              <DialogActions className={classes.dialogActionStyles}>
                <Button
                  onClick={handleCloseBulkUpdateConfirmDialog}
                  color="primary"
                  className={clsx(classes.btnStyles, classes.dialogCancelBtn)}
                  variant="contained"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleUserGroupBulkUpdate}
                  color="primary"
                  className={clsx(classes.btnStyles)}
                  variant="contained"
                >
                  Save
                </Button>
              </DialogActions>
            </Dialog>
            {/* Delete User Group Dialog - opens when 'Delete' button is clicked next to each usergroup entry in the table*/}
            <Dialog
              open={openDeleteUserDialog}
              onClose={handleCloseDeleteUserDialog}
              maxWidth="lg"
              className={classes.dialogStyles}
            >
              <DialogTitle id="add-userGroup-dialog">Delete User</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to delete this User? It will be
                  permanent
                </DialogContentText>
              </DialogContent>
              <DialogActions className={classes.dialogActionStyles}>
                <Button
                  onClick={handleCloseDeleteUserDialog}
                  color="primary"
                  className={clsx(classes.btnStyles, classes.dialogCancelBtn)}
                  variant="contained"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => handleDeleteUserDialog()}
                  color="primary"
                  className={clsx(
                    classes.btnStyles,
                    classes.dialogDeleteBtnStyles
                  )}
                  variant="contained"
                >
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
          </>
        }
      </section>
    </Container>
  );
};

export default BulkUpdate;
